import React from "react";
import PropTypes from "prop-types";
import LeftNavigation from "./LeftNavigation";
import CategoryList from "./CategoryList";
import { Loader } from "cxa-components";
import { injectIntl, intlShape } from "react-intl";
import messages from "../../../messagesDescription";

class TRS extends React.Component {
  componentDidMount() {
    this.props.getTrsBenefitPeriodList();
  }
  render() {
    const { getTrsDetail, trs, intl } = this.props;
    if (!trs.isBenefitPeriodsFetched) {
      return <Loader />;
    } else if (trs.benefitPeriods.length <= 0) {
      return (
        <div className="no-data-message">{intl.formatMessage({ ...messages.noTotalRewards })}</div>
      );
    } else {
      return (
        <div className="apl-dashboard grid__wrapper">
          <div className="grid__item grid__item--four">
            <LeftNavigation getTrsDetail={getTrsDetail} trs={trs} intl={intl} />
          </div>
          <div className="grid__item grid__item--eight">
            <CategoryList trs={trs} intl={intl} />
          </div>
        </div>
      );
    }
  }
}

TRS.propTypes = {
  getTrsBenefitPeriodList: PropTypes.func,
  getTrsDetail: PropTypes.func,
  trs: PropTypes.object,
  isBenefitPeriodsFetched: PropTypes.bool,
  intl: intlShape.isRequired,
};

export default injectIntl(TRS);



// WEBPACK FOOTER //
// ./components/employee/benefits/trs/TRS.jsx